import { lazy } from "react";

// project imports
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";

//Admin Profile and Password
const ChangePassword = Loadable(
  lazy(() => import("views/application/account-profile/changeAdminPassword.js"))
);
const UpdateProfile = Loadable(
  lazy(() => import("views/application/account-profile/updateProfile.js"))
);
const PlayersPage = Loadable(lazy(() => import("views/UsersTrip/index")));
const UserDetail = Loadable(lazy(() => import("views/UsersTrip/UserDetail")));
const UserSetting = Loadable(lazy(() => import("views/userSetting/index")));
const InvitationCodePage = Loadable(lazy(() => import("views/Invitation-Code/InvitationCode")));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/change-password",
      element: <ChangePassword />,
    },
    {
      path: "/update-profile",
      element: <UpdateProfile />,
    },
    {
      path: "/users",
      element: <PlayersPage />,
    },
    {
      path: "/user-trip-detail/:id",
      element: <UserDetail />
    },

    {
      path: "/invitation-code",
      element: <InvitationCodePage />
    },

    {
      path: "/user-settings",
      element: <UserSetting />,
    },
  ],
};

export default MainRoutes;
